import { computed, inject, Injectable, signal } from '@angular/core';

import { injectTellentNavigationViewID, TellentNavigationViewID } from '@core/tellent-types';

import { TellentNavigationRoutingService } from '../navigation/navigation-routing.service';

@Injectable()
export class TellentAppShellStateService {
  #forcedViewID = injectTellentNavigationViewID({ optional: true });
  #routingSvc = inject(TellentNavigationRoutingService);
  #isMobile = signal<boolean>(false);
  #isMinimalLayout = signal<boolean>(false);
  #view = computed(() => {
    if (this.#forcedViewID) return this.#forcedViewID;

    const match = this.#routingSvc.possibleMatch();

    if (match && match.id.startsWith('settings:')) return TellentNavigationViewID.Settings;

    return TellentNavigationViewID.Main;
  });

  public isMobile = computed(() => this.#isMobile());
  public isMinimalLayout = computed(() => this.#isMinimalLayout());
  public view = computed(() => this.#view());

  public setIsMobileContext(isMobile: boolean) {
    this.#isMobile.set(isMobile);
  }

  public setIsMinimalLayout(isMinimalLayout: boolean) {
    this.#isMinimalLayout.set(isMinimalLayout);
  }
}
